import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

function FoodGrid(food) {
  const [products, setProducts] = useState([]);


  // Get All Pducts 
  useEffect(() => {
    // Fetch products from the API
    axiosInstance.get('/api/products/getall')

    .then((response) => {

      // Assuming data is an array of cakes with a "category" property
      setProducts(response.data);
    })
      .catch((error) => console.error('Error fetching products:', error));
  }, []);

  return (
    <>
     <div className="flex mx-4 md:mx-auto text-center place-content-center mt-5">
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>

        <p className="text-center text-xl sm:text-2xl text-amber-600 font-bold mb-2 font-nav">Orders</p>
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
      </div>

      <p className="text-center font-bold font-roboto text-3xl sm:text-4xl mb-8">Most Order items</p>


      <div className="mx-4 md:mx-36 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
      {products.slice(0, 6).map((food) => (
        <div key={food.id} className="bg-white p-4 rounded-md hover:shadow-lg transition duration-300 transform hover:scale-105">
          <Link to={`/product/${food._id}`} className="block">
          <img width={400} height={400}
              className="w-full h-full object-cover"
              src={`${axiosInstance.defaults.baseURL}/${food.image}`}
              alt={food.name}
            />
          </Link>
          <div className="flex justify-between flex-col md:flex-row">
            <div className="names">
              <div className="text-sm md:text-sm lg:text-lg font-bold font-heading text-amber-500">
                {food.name}
              </div>
              <div className="text-sm text-gray-500">Rs: {food.price}</div>
            </div>
            <div className="mt-2">
              <div className="bg-green-400 w-9 h-9 rounded-full">
                <button className="material-symbols-outlined ml-2">
                  <Link to={`/product/${food._id}`}>
                    <FontAwesomeIcon
                      className="mt-2"
                      icon={faShoppingCart}
                      style={{ color: 'white', fontSize: '16px' }}
                    />
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

      <div className="text-center mt-4">
  <Link to="/gallery">
    <button className="bg-orange-300 md:w-3/4 w-60 text-white p-2 rounded-md backdrop-blur-sm backdrop-opacity-75 transition duration-300 ease-in-out hover:backdrop-opacity-100">
      Show More
    </button>
  </Link>
</div>
    </>
  );
}

export default FoodGrid;
